import { ProgressBarModule } from './progress-bar/progress-bar.module';

export const modules = [
  ProgressBarModule,
];
